// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__330mR","colBig":"styles_colBig__3rRm9","colSmall":"styles_colSmall__3C4Rw"};